import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import '../../../../assets/css/partials/PartsList.css'
import { Checkbox } from '@mui/material'
import moment from 'moment'

function PartsList({ recentParts, loading }) {
    const actionLabels = {
        'load': {
            label: 'В наличност',
            color: '#22C55E'
        },
        'unload': {
            label: 'Намерени',
            color: '#F59E0B'
        },
        'sold': {
            label: 'Потвърдени',
            color: '#EF4444'
        },
        'ordered': {
            label: 'Поръчани',
            color: '#3B82F6'
        },
        'new': {
            label: 'Нови',
            color: '#8B5CF6'
        },
        'reserved': {
            label: 'Резервирани',
            color: '#F59E0B'
        },
        'delivered': {
            label: 'Доставени',
            color: '#22C55E'
        },
        'returned': {
            label: 'Отказани',
            color: '#EF4444'
        },
        'damaged': {
            label: 'Изчакващи',
            color: '#F59E0B'
        }
    }

    if (loading) {
        return <Skeleton height={60} count={6} />
    }

    if (recentParts.length === 0) {
        return (
            <div className="alert info">
                Не бяха открити части.
            </div>
        )
    }

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('labels.part')}</th>
                    <th>{trans('labels.status')}</th>
                    <th>{trans('tables.addedAt')}</th>
                </tr>
            </thead>

            <tbody>
                {recentParts.map((part, idx) => (
                    <tr key={part.id}>
                        <td>
                            {part.part_name}
                        </td>
                        <td>
                            <div className='action'>
                                {part.action || part.status ?
                                    <>
                                        <span
                                            style={{
                                                backgroundColor: part?.color || '#E5E7EB'
                                            }}
                                        >

                                        </span>
                                        {actionLabels[part.action]?.label || part.action || part.status || '-'}
                                    </>
                                    :
                                    '-'
                                }
                            </div>
                        </td>
                        <td>
                            {moment(part.date).format('DD.MM.YYYY / HH:mm')}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default PartsList